var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import gsap from 'gsap';
import Carousel from './Micros/Carousel';
import { AngledContainer } from '../angledContainer/AngledContainer';
import './CardCarousel.scss';
var CardCarousel = function (_a) {
    var data = _a.data;
    var customPolygon = "polygon(0 0%, 0 110%, 102% 100%)";
    var _b = useState(0), scrolledBy = _b[0], setScrolledBy = _b[1];
    var scrollHandler = function (e) {
        var target = e.target;
        var scrollLeft = target.scrollLeft, scrollWidth = target.scrollWidth, clientWidth = target.clientWidth;
        var width = scrollWidth - clientWidth;
        setScrolledBy((scrollLeft / width) * 100);
    };
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.card-carousel-anime',
                start: 'top center',
            },
        });
        tl.to('.card-carousel-anime', {
            autoAlpha: 1,
            duration: 1,
            stagger: {
                each: 0.5,
            },
        });
    });
    return (_jsxs("div", { children: [_jsxs("div", __assign({ className: "card-carousel-section relative w-full snap-center" }, { children: [data.isAngledContainer && (_jsx(AngledContainer, { customPolygon: customPolygon, className: "lg:h-48 md:h-32 h-16 w-full bg-enblue-500" }, void 0)),
                    _jsxs("div", __assign({ className: "card-carousel1 relative w-full bg-enblue-500 px-0 pb-8" }, { children: [_jsx("h5", __assign({ style: { visibility: 'hidden' }, className: "card-carousel-anime card-carousel-anime1 carousel-title card-carouselcarousel__header font-base mx-auto w-3/4 py-5 text-center text-3xl md:pb-14 lg:w-full lg:pb-16 lg:text-5xl " }, { children: data.titleText }), void 0),
                            _jsx("div", __assign({ className: "card-carousel-anime", onScroll: scrollHandler, style: { visibility: 'hidden' } }, { children: _jsx(Carousel, { cardsArray: data.cardsArray }, void 0) }), void 0)] }), void 0)] }), void 0),
            _jsx("div", __assign({ className: "mx-[24px] h-[1px] " + (data.cardsArray.length >= 3 ? 'hideInXl' : 'md:hidden'), style: { backgroundColor: '#005f9e80', width: 'calc(100% - 48px)' } }, { children: _jsx("div", { className: "ml-[px] h-full w-[100px] bg-[#2d7fb6]", style: {
                        marginLeft: "calc(" + scrolledBy + "% - " + scrolledBy + "px)",
                    } }, void 0) }), void 0)] }, void 0));
};
export default CardCarousel;
